<template>
  <div>
    <el-page-header @back="goback" content=""> </el-page-header>
    <el-tabs v-model="activeName">
      <el-tab-pane label="在线报名" name="online">
        <register :matchId="matchId"></register>
      </el-tab-pane>
      <el-tab-pane label="正式报名表" name="entry">
        <registed :matchId="matchId"></registed>
      </el-tab-pane>
      <el-tab-pane label="赛事安排" name="scheduledetail">
        <match-schedule :matchId="matchId"></match-schedule>
      </el-tab-pane>
      <el-tab-pane :label="scheduleName" name="myschedule">
        <schedule-summary :matchId="matchId"></schedule-summary>
      </el-tab-pane>
      <el-tab-pane label="代表队管理" name="team" v-if="isHostOrAdmin()">
        <team :matchId="matchId"></team>
      </el-tab-pane>
        <el-tab-pane label="主办方" name="host" v-if="isAdmin()">
        <host :matchId="matchId"></host>
      </el-tab-pane>
      <el-tab-pane :label="scoreName" name="score">
        <score :matchId="matchId"></score>
      </el-tab-pane>
      <el-tab-pane label="组别设项" name="group">
        <group :matchId="matchId"></group>
      </el-tab-pane>
      <el-tab-pane label="返点" name="rebate" v-if="isHostOrAdmin()">
        <rebate :matchId="matchId" v-role="['1','3']"></rebate>
      </el-tab-pane>
      <el-tab-pane label="报名规则" v-if="isAdmin()" name="rules">
        <rule :matchId="matchId"></rule>
      </el-tab-pane>
      <el-tab-pane label="团体舞价格区间" v-if="isAdmin()" name="teamregistrationconfig">
        <team-registration-config :matchId="matchId"></team-registration-config>
      </el-tab-pane>
      <el-tab-pane label="图表" v-if="isAdmin()" name="chart">
        <chart :matchId="matchId"></chart>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Group from '../components/Group'
import Register from '../components/PlayerRegister'
import Team from '../components/Team'
import Rebate from '../components/Rebate'
import Rule from '../components/MatchRule'
import Score from '../components/Score'
import Registed from '../components/Registred'
import MatchSchedule from '../components/MatchSchedule.vue'
import ScheduleSummary from '../components/ScheduleSummary'
import Chart from '../components/PlayerChartSet'
import TeamRegistrationConfig from '../components/TeamRegistrationConfig.vue'
import Host from '../components/Host'

export default {
  components: {
    Group,
    Register,
    Team,
    Rebate,
    Rule, Score,
    Registed,
    MatchSchedule,
    ScheduleSummary,
    Chart,
    TeamRegistrationConfig,
    Host
  },
  data () {
    return {
      activeName: 'online',
      scheduleName: '',
      scoreName: '',
      matchId: this.$route.query.matchId,
    };
  },
  methods: {
    goback () {
      this.$router.go(-1)
    },
    isHost () {
      return sessionStorage.getItem('userType') == "3"
    },
    isAdmin () {
      return sessionStorage.getItem('userType') == "1"
    },
    isHostOrAdmin () {
      return sessionStorage.getItem('userType') == "3" || sessionStorage.getItem('userType') == "1"
    }
  }, mounted () {
    if (sessionStorage.getItem('userType') == "2") {
      this.scoreName = '我的成绩表'
      this.scheduleName = '我的赛程'
    }
    else {
      this.scheduleName = "赛程表"
      this.scoreName = "成绩表"
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/MatchDetail.vue